export default __webpack_public_path__ + "static/paras1-6b064526a4f49d862d86e5d83199f904.jpg";